import React, { ReactNode } from 'react';
import { colors } from '../../../../colorVars';
import style from './NumericalInput.module.css';

interface NumericalInputProps {
  margin?: string;
  /**Width of input */
  width?: string;

  /**Icon to display in left portion of input */
  icon?: string;

  onChange: (value: number | string) => void;

  controlledValue: number | string;

  disabled?: boolean;
  backgroundColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  fontColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  fontSize: string;
  maxHeight?: string;
}

export const NumericalInput: React.FC<NumericalInputProps> = ({
  width,
  icon,
  controlledValue,
  disabled,
  onChange,
  backgroundColor,
  fontColor,
  fontSize,
  maxHeight,
  margin,
}: NumericalInputProps) => {
  return (
    <div
      className={disabled ? style.disabled : style.container}
      style={{
        margin,
        backgroundColor: colors[backgroundColor],
        color: colors[fontColor],
        fontSize,
        maxHeight,
      }}
    >
      {icon ? (
        <span className={style.span} style={{ opacity: disabled ? 0.4 : 1 }}>
          {icon}
        </span>
      ) : null}
      <input
        disabled={disabled}
        style={{
          width,
          fontSize,
          backgroundColor: colors[backgroundColor],
          color: colors[fontColor],
          opacity: disabled ? 0.4 : 1,
        }}
        value={controlledValue}
        type="number"
        onChange={({ target }) => onChange(target.value)}
        className={style.input}
      />
    </div>
  );
};
